module.exports = __webpack_public_path__ + "static/media/151.2ae31140.webp";